(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[97766],{

/***/ 97766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Modals_GetBookModal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/containers/Modal/utils/useProps.js





var useProps = function(_param) {
    var show = _param.show, close = _param.close, props = (0,_object_without_properties/* default */.Z)(_param, [
        "show",
        "close"
    ]);
    var modalRef = (0,react.useRef)(null);
    var handleOnClick = function(param) {
        var target = param.target;
        if (!(modalRef === null || modalRef === void 0 ? void 0 : modalRef.current.isEqualNode(target))) {
            return;
        }
        close();
    };
    (0,react.useEffect)(function() {
        (0,helper/* setOverflowForBody */.zd)(show);
    }, [
        show
    ]);
    (0,react.useEffect)(function() {
        var handleOnKeyDown = function(param) {
            var key = param.key;
            if (key === "Escape") {
                close();
            }
        };
        document.addEventListener("keydown", handleOnKeyDown);
        return function() {
            return document.removeEventListener("keydown", handleOnKeyDown);
        };
    }, [
        close
    ]);
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        show: show,
        close: close,
        handleOnClick: handleOnClick,
        modalRef: modalRef
    });
};
/* harmony default export */ var utils_useProps = (useProps);

// EXTERNAL MODULE: ./UI/containers/Modal/Modal.module.scss
var Modal_module = __webpack_require__(6494);
var Modal_module_default = /*#__PURE__*/__webpack_require__.n(Modal_module);
;// CONCATENATED MODULE: ./UI/containers/Modal/index.jsx








var Svg = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6778).then(__webpack_require__.bind(__webpack_require__, 6778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6778)
            ];
        }
    }
});
var Modal = function(props) {
    var ref = utils_useProps(props), show = ref.show, close = ref.close, children = ref.children, className = ref.className, modalRef = ref.modalRef, handleOnClick = ref.handleOnClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: classnames_default()((Modal_module_default()).modalWindowContainer, (0,_define_property/* default */.Z)({}, (Modal_module_default()).show, show)),
        onClick: handleOnClick,
        ref: modalRef,
        role: "dialog",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((Modal_module_default()).modalWindow, className),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                    className: (Modal_module_default()).svg,
                    type: constants/* SVG_IMAGES_TYPES.closeSvg */.NL.closeSvg,
                    handleOnClick: close
                }),
                children
            ]
        })
    });
};
Modal.propTypes = {
    show: (prop_types_default()).bool.isRequired,
    close: (prop_types_default()).func.isRequired,
    children: (prop_types_default()).node.isRequired,
    className: (prop_types_default()).string
};
/* harmony default export */ var containers_Modal = (Modal);

// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./UI/components/Typography/utils/useTypography.js
var useTypography = __webpack_require__(18422);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./redux/apis/dataSending.js
var dataSending = __webpack_require__(56962);
;// CONCATENATED MODULE: ./UI/components/Modals/GetBookModal/utils/useProps.js




var useProps_useProps = function(_param) {
    var downloadLink = _param.downloadLink, show = _param.show, props = (0,_object_without_properties/* default */.Z)(_param, [
        "downloadLink",
        "show"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,dataSending/* useSubscribeMutation */.iD)({
        fixedCacheKey: dataSending/* SUBSCRIPTION_CASH_KEY */.X3
    }), 2), _ = ref[0], ref1 = ref[1], tmp = ref1.data, isSubscribed = (tmp === void 0 ? {} : tmp).isSubscribed;
    return (0,_object_spread/* default */.Z)({
        isSubscribed: isSubscribed,
        show: show,
        downloadLink: downloadLink
    }, props);
};
/* harmony default export */ var GetBookModal_utils_useProps = (useProps_useProps);

// EXTERNAL MODULE: ./UI/components/Modals/GetBookModal/GetBookModal.module.scss
var GetBookModal_module = __webpack_require__(27462);
var GetBookModal_module_default = /*#__PURE__*/__webpack_require__.n(GetBookModal_module);
;// CONCATENATED MODULE: ./UI/components/Modals/GetBookModal/index.jsx







var GetBookForm = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(33714), __webpack_require__.e(84602), __webpack_require__.e(21148), __webpack_require__.e(96419), __webpack_require__.e(1307)]).then(__webpack_require__.bind(__webpack_require__, 61710));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61710)
            ];
        }
    }
});
var Typography = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 54223).then(__webpack_require__.bind(__webpack_require__, 59654));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59654)
            ];
        }
    }
});
var Button = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 49105));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49105)
            ];
        }
    }
});
var GetBookModal = function(props) {
    var ref = GetBookModal_utils_useProps(props), show = ref.show, close = ref.close, bookCover = ref.bookCover, buttonText = ref.buttonText, isSubscribed = ref.isSubscribed, downloadLink = ref.downloadLink, withContact = ref.withContact, modalTitle = ref.modalTitle, modalSubtitle = ref.modalSubtitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(containers_Modal, {
        show: show,
        close: close,
        className: (GetBookModal_module_default()).modal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (GetBookModal_module_default()).container,
            children: [
                modalTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, {
                    size: useTypography/* TYPOGRAPHY_SIZE.headline38 */.y3.headline38,
                    isBold: true,
                    className: (GetBookModal_module_default()).modalTitle,
                    children: modalTitle
                }),
                modalSubtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, {
                    size: useTypography/* TYPOGRAPHY_SIZE.paragrapgh16 */.y3.paragrapgh16,
                    className: (GetBookModal_module_default()).modalSubtitle,
                    children: modalSubtitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                    src: bookCover === null || bookCover === void 0 ? void 0 : bookCover.url,
                    alt: bookCover === null || bookCover === void 0 ? void 0 : bookCover.alt,
                    className: (GetBookModal_module_default()).image
                }),
                !isSubscribed && /*#__PURE__*/ (0,jsx_runtime.jsx)(GetBookForm, {
                    isOpen: show,
                    buttonText: buttonText,
                    downloadLink: downloadLink,
                    withContact: withContact
                }),
                isSubscribed && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, {
                            size: useTypography/* TYPOGRAPHY_SIZE.headline24 */.y3.headline24,
                            isBold: true,
                            children: "Thank you!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                            className: (GetBookModal_module_default()).backButton,
                            onClick: close,
                            children: "Go back"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Modals_GetBookModal = (GetBookModal);


/***/ }),

/***/ 27462:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal":"GetBookModal_modal__8VUU_","container":"GetBookModal_container___fjGj","image":"GetBookModal_image__b86rv","backButton":"GetBookModal_backButton__bQgiS","modalTitle":"GetBookModal_modalTitle__aV_pR","modalSubtitle":"GetBookModal_modalSubtitle__DyiUW"};

/***/ }),

/***/ 6494:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalWindowContainer":"Modal_modalWindowContainer__a4FkL","modalWindow":"Modal_modalWindow__rYs1O","svg":"Modal_svg__QsBWf","show":"Modal_show__O58uS"};

/***/ })

}]);